module.exports = __webpack_public_path__ + "assets/img/registerBtn.f561619b.png";